import styled from 'styled-components';

interface Props {
  width?: string;
}

export const InfoDocument = styled.div`
  display: flex;
  width: 370px;
  align-items: center;
  color: #666666;
  margin-top: 8px !important;
  margin-bottom: 0px;
  > div {
    height: 20px;
    width: 20px;
    margin-right: 8px;
    border: 1px solid #666666;
    border-radius: 50%;
    text-align: center;
    font-weight: bold;
  }
  p {
    margin: 0;
    width: 90%;
    font-size: 12px;
  }
  @media (max-width: 650px) {
    width: 100%;
  }
`;

export const FormInput = styled.div<Props>`
  width: 100%;
`;
